module.exports = __webpack_public_path__ + "static/media/Catalogo-Proveedores.1b33208a.png";